module.exports = __webpack_public_path__ + "components/modal-app-popup/static/edge-icon-df1e6047e8fb4a77bfe7abd924eaf490.webp";